import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// The phone's way into the sections: an icon and no text, so its name lives
// in aria-label and changes with what pressing it will do. Hidden on desktop,
// where the links are already on the bar.
//
// The ref arrives as a prop (React 19), so the top bar can return focus here
// when the menu is closed from inside.
export function MenuButton({ ref, open, onClick }) {
  const { text } = useLanguage();

  let label = text.openMenu;
  let icon = styles.menu;

  if (open === true) {
    label = text.closeMenu;
    icon = styles.close;
  }

  return (
    <button
      ref={ ref }
      type='button'
      className={ styles.button }
      aria-label={ label }
      aria-expanded={ open }
      aria-controls='main-menu'
      onClick={ onClick }
    >
      <span className={ icon }></span>
    </button>
  );
}
